import { SVTable } from '@/components/core';
import { MESSAGES } from '@/constants/messages';
import { useDownloadPresignedUrl } from '@/hooks/requests/usePresignedUrls';
import { SVTableRow } from '@/types/common';
import showToast from '@/utils/toast';
import { CloudDownload } from '@mui/icons-material';
import { Card, IconButton, Typography } from '@mui/material';

type ExternalAccountDocumentsProps = {
  uuid: string;
  documents: string[];
};

export default function ExternalAccountDocuments({
  uuid,
  documents,
}: ExternalAccountDocumentsProps) {
  const { downloadPresignedUrl } = useDownloadPresignedUrl();
  async function onDownloadDocument(uuid: string, file: string) {
    try {
      const url = new URL(file);
      const response = await downloadPresignedUrl({
        type: 'business document',
        uuid,
        file: url.pathname.slice(1),
      });
      window.open(response.url, '_blank');
    } catch {
      showToast({
        type: 'error',
        data: {
          content: MESSAGES.genericError,
        },
      });
    }
  }

  const rows: SVTableRow[] = documents.map(document => {
    return {
      key: `documentRow${document}`,
      cells: [
        {
          content: document,
          type: 'text',
          key: `filename${document}`,
        },
        {
          content: (
            <IconButton onClick={() => onDownloadDocument(uuid, document)}>
              <CloudDownload />
            </IconButton>
          ),
          type: 'custom',
          key: `download${document}`,
        },
      ],
    };
  });

  return (
    <Card>
      <Typography variant="h5" mb={2}>
        Proofs of Ownership
      </Typography>
      {documents.length === 0 ? (
        <Typography>No proofs of ownership added</Typography>
      ) : (
        <SVTable
          ariaLabel="Documents"
          headers={[
            {
              content: 'Name',
              key: 'name',
            },
            {
              content: 'Download',
              key: 'download',
            },
          ]}
          rows={rows}
        />
      )}
    </Card>
  );
}
